<div class="modal-header bg-primary text-light">
  <h5 class="modal-title">Measured Windows Details</h5>
</div>
<div class="modal-body">
  <div class="row">
      <table class="table table-responsive">
          <thead>
              <tr>
                  <th scope="col-1" *ngIf="isEdit"></th>
                  <th scope="col-2">Orientation</th>
                  <th scope="col-2">Glazing Type</th>
                  <th scope="col-1">Roof Window</th>
                  <th scope="col-1" >PVC Frame</th>
                  <th scope="col-1" >Glazing Gap</th>
                  <th scope="col-1">Area</th>
                  <th scope="col-1" >U-value</th>
                  <th scope="col-1" >G-value</th>
                  <th scope="col-1" >Data Source</th>
              </tr>
          </thead>
          <tbody>
              <ng-container *ngFor="let detail of openingsMeasurementWindowsDetails; let i = index">
                  <tr *ngIf="detail.windowLocation == windowLocation">
                      <td *ngIf="isEdit">
                          <button type="button" class="btn btn-warning" data-dismiss="modal" (click)="remove(detail)" aria-label="Delete detail">Delete</button>
                      </td>
                      <td>
                          <div class="form-group">
                              <select id="detail_orientation" class="form-control" [(ngModel)]="detail.orientation" [disabled]="!isEdit">
                                  <option *ngFor="let orientation of getOrientations(detail.windowType)" [value]="orientation.lookupValue">{{ orientation.lookUpItem }}</option>
                              </select>
                          </div>
                      </td>
                      <td>
                          <div class="form-group">
                              <select class="form-control" id="detail_glazingType" [(ngModel)]="detail.glazingType" (change)="onGlazingTypeChange(i, $event.target.value)" [disabled]="!isEdit">
                                  <option></option>
                                  <option *ngFor="let glazingType of glazingTypes" [value]="glazingType.lookupValue">{{ glazingType.lookUpItem }}</option>
                              </select>
                          </div>
                      </td>
                      <td>
                          <div class="form-group">
                              <input id="detail_windowType" type="checkbox" class="form-checkbox" [(ngModel)]="detail.windowType" (change)="onWindowTypeChange(i, $event.target)" [disabled]="!isEdit" />
                          </div>
                      </td>
                        <td>
                            <div class="form-group">
                            <input id="detail_pvcFrame" type="checkbox" class="form-checkbox" [(ngModel)]="detail.pvcFrame" (change)="onPvcFrameChange(i, $event.target)" [disabled]="!isEdit || (detail.glazingType !== '1' && detail.glazingType !== '3') " />
                            </div>
                        </td>
                        <td >
                            <div class="form-group">
                            <select id="detail_glazingGap" class="form-control" [(ngModel)]="detail.glazingGap" (change)="onGlazingGapChange(i, $event.target.value)" [disabled]="!isEdit || (detail.glazingType !== '1' && detail.glazingType !== '3' ) || !detail.pvcFrame">
                                <option></option>
                                <option *ngFor="let gap of getGlazingGaps(detail.pvcFrame)" [value]="gap.lookupValue">{{ gap.lookUpItem }}</option>
                            </select>
                            </div>
                        </td>
                        
                        <ng-template #emptyCell><td></td></ng-template>
                      <td>
                          <div class="form-group">
                              <input type="number" class="form-control" [(ngModel)]="detail.windowArea.value" [ngStyle]="{
                                'border': detail.windowArea.value === 0 ? '0.5px solid red' : '1px solid rgba(47, 79, 79, 0.175) '
                              }" [disabled]="!isEdit" min="0" step="0.01" />
                          </div>
                      </td>
                      <td>
                          <div class="form-group">
                              <input type="number" class="form-control" [(ngModel)]="detail.windowTransmissionDetails.uValue" [disabled]="!isEdit || (detail.glazingType !== '7' && detail.glazingType !== '8')" min="0" step="0.01" />
                          </div>

                      </td>
                      <td >
                          <div class="form-group">
                              <input type="number" class="form-control" [(ngModel)]="detail.windowTransmissionDetails.solarTransmittance" [disabled]="!isEdit || (detail.glazingType !== '7' && detail.glazingType !== '8')" min="0" step="0.01" />
                          </div>
                      </td>
                      <td >
                          <div class="form-group" >
                              <select id="detail_Data_Source" class="form-control" [(ngModel)]="detail.windowTransmissionDetails.dataSource" [disabled]="!isEdit || (detail.glazingType !== '7' && detail.glazingType !== '8')">
                                  <option *ngFor="let dataSource of getWindowsTransmissionDataSource()" [value]="dataSource.lookupValue">{{ dataSource.lookUpItem }}</option>
                              </select>
                          </div>

                      </td>
                  </tr>
              </ng-container>
          </tbody>
      </table>
  </div>
</div>
<div class="modal-footer">
  <button type="button" *ngIf="isEdit" (click)="addNew()" class="btn btn-primary">Add New</button>
  <button type="submit" class="btn btn-outline-dark" (click)="onClose()" data-dismiss="modal">Close</button>
</div>